/**
 * Created by noOne on 09/08/2017.
 */
var config = {
    //=========================================================================================================//
    //=========================================================================================================//

    //--how long the course starts at--//
    "basicLength": 50000,

    //--random extra length to add to this--//
    "randomLength": 2,

    //--random variation for distance between obstacles--//
    "randomObsDist": 200,

    //--minimum cannon back rotation--//
    "minCannonRot": -1,

    //--total number of stars (note they get recycled)--//
    "numStars": 100,

    //--total number of obstacles (again, they get recycled so no need to set it too high)--//
    "numObs": 15,

    //--total balloons (recycled as well but if you turn this up you will get lots of balloons to bounce off)--//
    "numBalloons": 5,

    //=========================================================================================================//
    //=========================================================================================================//

    //--max x velocity (prevents happo reaching light speed)--//
    "maxDx": 100,

    //--boost force--//
    "boostPower": 50,

    //--force of gravity (make sure its negative otherwise happo will fall upwards)--//
    "gravity": -1.4,

    //--how hard bouncing pushes the player forward (could probably
    // be negative and object bounces would slow the player--//
    "bouncePushForward": 5,

    //--how much bounce you get from objects--//
    "yBounceFactor": 2.5,

    //=========================================================================================================//
    //==As long as a texture name, sound name and bounce factor is provided any new objects added should work==//
    //=========================================================================================================//
    /**
     * how bouncy each individual object is
     */
    "bounceFactors": {
        "beach_ball": 30,
        "bucket": 22,
        "hammock": 25,
        "parasol": 35,
        "trampoline": 40,
        "tub": 25,
        "yoga_ball": 25,
        "none": 20,
        "pit": 6,
        "spring": 35,
        "spring_2": 40,
        "float": 35,
        "drumm": 25,
        "deck_chair_1": 25,
        "balloons": 35
    },

    //--obj texture names--//
    "objTextures": {
        0: "beach_ball",
        1: "bucket",
        2: "hammock",
        3: "parasol",
        4: "trampoline",
        5: "tub",
        6: "yoga_ball",
        7: "spring",
        8: "float",
        9: "drumm",
        10: "deck_chair_1",
        11: "spring_2"
    },

    //--obj sound names--//
    "sounds": {
        "beach_ball": "sfx_bounce_yogaball_00",
        "bucket": "sfx_bounce_bucket_00",
        "hammock": "sfx_bounce_hammock_00",
        "parasol": "sfx_bounce_plastic_00",
        "trampoline": "sfx_bounce_trampoline_00",
        "tub": "sfx_bounce_plastic_00",
        "yoga_ball": "sfx_bounce_yogaball_00",
        "none": "sfx_happo_impact_00",
        "spring": "sfx_bounce_springboard_00",
        "spring_2": "sfx_bounce_springboard_00",
        "float": "sfx_bounce_plastic_00",
        "drumm": "sfx_bounce_drum_00",
        "deck_chair_1": "sfx_bounce_hammock_00",
        "balloons": "sfx_bounce_plastic_00"
    }
};

export default config;